import {useEffect, useState} from 'react';

import {Elements} from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm'
import logo from './Assets/lumeylines.png'
//import dmsans from './Assets/DMSans/font.css'
const urlParams = new URLSearchParams(window.location.search);


  const amount = urlParams.get('amount');
    // make sure that the amount is not over $500 and is not less than $1
   

function Payment(props) {
  const { stripePromise } = props;
  const [ clientSecret, setClientSecret ] = useState('');
  const fonts = [
    {
      // integrate your font into stripe
      cssSrc: "https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap",
    }
  ]
  // Get the payment total from the URL query string (e.g. ?amount=5)
  if (amount > 500 || amount < 1) {
    window.location.href = '/';
  }
  const appearance = {
    theme: 'night',
    variables: {
      fontFamily: 'DM Sans',
      fontWeightNormal: '500',
      fontWeightMedium: '500',
      fontWeightBold: '700',
      borderRadius: '8px',
      colorBackground: '#000000',
      colorPrimary: '#bcdceb',
      colorPrimaryText: '#ffffff',
      colorText: 'white',
      colorTextSecondary: 'white',
      colorTextPlaceholder: '#727F96',
      colorIconTab: 'white',
      colorLogo: 'dark'
    },
    rules: {
      '.Input, .Block': {
        backgroundColor: 'transparent',
        border: '1.5px solid var(--colorPrimary)'
      }
    }
  }
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads, double triple checking that the amount is not too high or low (using the amount from the URL query string)
    fetch(`https://stripe.lumey.dev/create-payment-intent?amount=${amount}`)
    .then((res) => res.json())
    .then(({clientSecret}) => setClientSecret(clientSecret));
  }, []);


  return (
    <>
      <img src={logo} alt='Logo' id='logo'></img>
      <h1>Payment</h1>
      <h2>Your total will be ${amount}</h2>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret, fonts, appearance }}>
          <CheckoutForm />
        </Elements>
      )}
    </>
  );
}

export default Payment;
